// extracted by mini-css-extract-plugin
export var bounce = "_kd-1";
export var generatingText = "_kd-6";
export var lightning = "_kd-4";
export var popup = "_kd-5";
export var progressBar = "_kd-7";
export var progressFill = "_kd-8";
export var progressShimmer = "_kd-9";
export var progressText = "_kd-a";
export var shimmer = "_kd-3";
export var uploadIcon = "_kd-0";
export var uploadingText = "_kd-2";